export default __webpack_public_path__ + "locales/ro/Profile.json?hash=bd16688f6f8edfef52bd128d0c255782";